import React, { useState, useEffect, useContext } from 'react';
import { Layout, Result, Button, Spin } from 'antd';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import get from 'lodash/get';
import styled from 'styled-components';
import { store, SET_USER_SELF } from '../utils/store';
import { getUserSelf } from '../api';
import Head from '../components/Header';
import Organizations from './Organizations';
import WingopsUsers from './WingopsUsers';
import Aircrafts from './Aircrafts';

const { Content } = Layout;

const MainContent = styled(Content)`
	width: 100%;
	height: calc(100vh - 64px);
	overflow-y: auto;
	padding: 24px 50px;
`;

function App() {
	// TODO move it later to parent container
	const [loading, setloading]: any = useState(false);
	const globalState = useContext(store);
	const [err, setErr]: any = useState(null);
	const { dispatch, state }: any = globalState;

	async function fetchUserSelf() {
		setloading(true);
		try {
			const selfData = await getUserSelf();
			dispatch({ type: SET_USER_SELF, userSelf: selfData });
		} catch (e) {
			setErr(true);
		}

		setloading(false);
	}

	useEffect(() => {
		fetchUserSelf();
		const viewportMeta = document.getElementsByTagName('meta').namedItem('viewport');

		if (viewportMeta) {
			viewportMeta.setAttribute('content', 'width=1600');
		}
	}, []);

	if (loading) {
		return <Result icon={<Spin size="large" />} title="Loading Backoffice..." />;
	}

	if (err) {
		return <Result status="403" title="Access Denied" subTitle="You do not have permission to view this page." />;
	}

	return get(state, 'userSelf.id') ? (
		<Router>
			<Layout style={{ minWidth: 1024 }}>
				<Head />
				<MainContent>
					<Switch>
						<Route exact path="/">
							<Organizations />
						</Route>
						<Route exact path="/users">
							<WingopsUsers />
						</Route>
						<Route exact path="/aircrafts">
							<Aircrafts />
						</Route>
						<Route
							render={() => (
								<Result
									status="404"
									title="404"
									subTitle="Sorry, the page you visited does not exist."
									extra={<Button type="primary">Back to organizations</Button>}
								/>
							)}
						/>
					</Switch>
				</MainContent>
			</Layout>
		</Router>
	) : null;
}

export default App;
